<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <a-layout-sider v-model="collapsed" :trigger="null" collapsible>
      <div class="logo">
        <img class="logo-img" src="../../public/images/logo.png" />
      </div>
      <d-menu />
    </a-layout-sider>
    <a-layout>
      <a-layout-header style="background: #fff; padding: 0">
        <a-icon
          class="trigger"
          :type="collapsed ? 'menu-unfold' : 'menu-fold'"
          @click="() => (collapsed = !collapsed)"
        />
        <d-header />
      </a-layout-header>
      <a-layout-content :style="{ margin: '15px' }">
        <router-view/>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import menu from './modules/menu'
import header from './modules/header'
export default {
  components:{
    'd-menu': menu,
    'd-header': header
  },
  data() {
    return {
      collapsed: true,
    };
  },
  mounted() {
    this.$nextTick(function(){
      this.collapsed = false
    });
  }
};
</script>
<style>
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  height: 32px;
  margin: 16px;
  text-align: center;
  overflow: hidden;
}
.logo-img{
  height: 100%;
}
</style>